import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS } from "library/shared";
import { IUserAssignment } from "library/types";
import { useMutation } from "react-query";
import api from "service/api";
import { useInvalidateGetUserAssignments } from "./useGetUserAssignments";

type Params = {
  countryCode: number | string;
  clientInternalNumberGOS: number | string;
  hbhUserAssignmentId: number | string;
  payload: {
    rowVersion: string;
  };
};

const deleteUserAssignment = async ({
  countryCode,
  clientInternalNumberGOS,
  hbhUserAssignmentId,
  payload,
}: Params): Promise<IUserAssignment> => {
  const response = await api.patch(
    `/hbhuserassignment/delete/${countryCode}/${clientInternalNumberGOS}/${hbhUserAssignmentId}`,
    {
      ...payload,
    }
  );

  return response.data as IUserAssignment;
};

export function useDeleteUserAssignment(refetch = true) {
  const invalidateUserAssignments = useInvalidateGetUserAssignments();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useMutation(deleteUserAssignment, {
    mutationKey: MUTATION_KEYS.deleteUserAssignment,
    onSuccess: () => {
      if (refetch) {
        invalidateUserAssignments();
      }
    },
    onError: (error) => {
      handleAddAxiosErrorNotification(error);
    },
  });
}
